import classNames from "classnames";
import styles from './game.module.scss';
import {observer} from 'mobx-react';

export const GameStatus = observer(({item}) => {
  const {isLive, topStatus, gtd} = item

  return isLive ? <div className={classNames(styles.live)}><bdi>{`${gtd}`}</bdi></div> : <div className={classNames(styles.status_text)}>{topStatus}</div>;
});
